export type RepositoryType = 'jfrog' | 'github' | 'azure' | 'google';

export interface RepositoryTypeCard {
  type: RepositoryType;
  name: string;
  icon: string;
  description: string;
  comingSoon?: boolean;
}

export const repositoryTypes: RepositoryTypeCard[] = [
  {
    type: 'jfrog',
    name: 'JFrog Artifactory',
    icon: 'icon-package',
    description: 'Configure external JFrog Artifactory repository connections for multi-vendor software package support.'
  },
  {
    type: 'github',
    name: 'GitHub Packages',
    icon: 'icon-code',
    description: 'Connect to GitHub Container Registry for accessing container images and packages.',
    comingSoon: true
  },
  {
    type: 'azure',
    name: 'Azure Container Registry',
    icon: 'icon-cloud',
    description: 'Integrate with Azure Container Registry (ACR) for enterprise container image management.',
    comingSoon: true
  },
  {
    type: 'google',
    name: 'Google Artifact Registry',
    icon: 'icon-layers',
    description: 'Connect to Google Cloud Artifact Registry for container images and language packages.',
    comingSoon: true
  }
];

export const getRepositoryTypeInfo = (type: RepositoryType) => {
  return repositoryTypes.find((rt) => rt.type === type);
};

export const getStatusColor = (status: 'connected' | 'disconnected' | 'error') => {
  switch (status) {
    case 'connected':
      return '#28a745';
    case 'error':
      return '#6c757d';
    case 'disconnected':
      return '#dc3545';
    default:
      return '#6c757d';
  }
};
